import { createFileRoute } from '@tanstack/react-router'

import { PurchaseOrderFormPage } from '@/features/inventory/components/purchase-order-form-page'

export const Route = createFileRoute('/_app/inventory/po/create')({
  loader: () => {
    return {
      crumb: 'Buat PO',
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()

  return (
    <PurchaseOrderFormPage
      mode='create'
      onBack={() => navigate({ to: '/inventory/po', replace: true })}
    />
  )
}
